import { render, staticRenderFns } from "./ResponsibilityAttachedRolesTab.vue?vue&type=template&id=4d6f9b4c&scoped=true"
import script from "./ResponsibilityAttachedRolesTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ResponsibilityAttachedRolesTab.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6f9b4c",
  null
  
)

export default component.exports